<template>
    <div class="balance-manager">
      <div>
        <label title="用户昵称" class="info">用户昵称</label>
        <a-input style="max-width: 10%; margin-right: 20px" placeholder="支持拼音模糊匹配" v-model="searchNickname" @pressEnter="search"/>
        <label title="微信号" class="info">微信号</label>
        <a-input style="max-width: 10%; margin-right: 20px" placeholder="仅支持全匹配" v-model="searchUsername" @pressEnter="search"/>
        <a-range-picker
          :ranges="{ 今天: [moment().startOf('day'), moment()], 本周: [moment().startOf('week'), moment()], 本月: [moment().startOf('month'), moment()] }"
          format="YYYY/MM/DD HH:mm:ss"
          @change="onChange"
          style="margin-right: 20px"
          :placeholder="['开始日期', '结束日期']"
          v-model="rangeDate"
          @pressEnter="search"
        />
        <a-button type="primary" @click="search">搜索</a-button>
        <a-button type="primary" @click="clear">清空</a-button>
      </div>
      <div>
        <a-button type="primary" @click="outputExcel" style="margin:10px 10px 0 10px;">导出</a-button>
      </div>
      <a-table :columns="columns"
               :dataSource="data"
               :loading="loading"
               :pagination="pagination"
               @change="handleTableChange"
               class="balance-table"
               style="font-size: 12px !important; margin-top: 10px"
      >
        <!-- 用户 -->
        <div class="avatar-36-con" slot="client" slot-scope="text">
          <img class="avatar" :src="text.avatar_url"/>
          <div class="nickname">{{text.nickname + '（' + text.username + '）'}}</div>
        </div>
      </a-table>
    </div>
</template>

<script>
import moment from 'moment'
const BALANCE_LOG_TYPE = {
  0: '购买群',
  1: '升级VIP',
  2: '系统赠送试用群紫豆',
  3: '普通群续费',
  4: 'VIP群续费',
  5: '人工操作',
  6: '充值',
  7: '购买VIP群',
  8: '一起赚紫豆活动邀请奖励',
  9: '一起赚紫豆活动被邀请奖励',
  10: '一起赚紫豆活动返佣奖励',
  11: '一起赚紫豆活动被邀请人拉群奖励'
}

const BALANCE_LOG_STATUS = {
  0: '支付失败',
  1: '支付成功',
  2: '待支付',
  3: '扣费成功',
  4: '扣费失败',
  5: '系统赠送'
}
const axios = require('axios')
export default {
  name: 'BalanceManage',
  data () {
    return {
      getBalanceLogListUrlPostFix: 'UBalance/get_balance_logs',
      getBalanceLogListExcelUrlPostFix: 'UBalance/get_balance_logs_excel',
      pagination: {
        hideOnSinglePage: true,
        // showTotal: total => `共 ${total} 个群`,
        pageSize: 20,
        current: 1
      },
      data: [],
      loading: false,
      columns: [{
        title: '交易ID',
        dataIndex: 'balance_log_id'
      }, {
        title: '用户',
        dataIndex: 'client',
        scopedSlots: { customRender: 'client' }
      }, {
        title: '交易类型',
        dataIndex: 'type',
        filters: [{
          text: '购买群',
          value: '0'
        }, {
          text: '升级VIP',
          value: '1'
        }, {
          text: '系统赠送试用群紫豆',
          value: '2'
        }, {
          text: '普通群续费',
          value: '3'
        }, {
          text: 'VIP群续费',
          value: '4'
        }, {
          text: '人工操作',
          value: '5'
        }, {
          text: '充值',
          value: '6'
        }, {
          text: '购买VIP群',
          value: '7'
        }]
      }, {
        title: '积分变动',
        dataIndex: 'change'
      }, {
        title: '交易后积分',
        dataIndex: 'balance'
      }, {
        title: '交易状态',
        dataIndex: 'status',
        filters: [{
          text: '支付失败',
          value: '0'
        }, {
          text: '支付成功',
          value: '1'
        }, {
          text: '待支付',
          value: '2'
        }, {
          text: '扣费成功',
          value: '3'
        }, {
          text: '扣费失败',
          value: '4'
        }, {
          text: '系统赠送',
          value: '5'
        }]
      }, {
        title: '订单时间',
        dataIndex: 'create_time'
      // }, {
      //   title: '订单详情',
      //   dataIndex: 'detail',
      //   scopedSlots: { customRender: 'detail' }
      // }, {
      //   title: '操作',
      //   dataIndex: 'actions',
      //   scopedSlots: { customRender: 'actions' }
      }],
      typeList: [],
      statusList: [],
      searchNickname: '',
      searchUsername: '',
      rangeDate: [],
      startTime: 0,
      endTime: 0
    }
  },
  computed: {
    params: function () {
      // console.log('filter', this.filters)
      return {
        // results: this.pagination.pageSize,
        page: this.pagination.current,
        page_size: this.pagination.pageSize,
        type_list: this.typeList,
        status_list: this.statusList,
        nickname: this.searchNickname,
        username: this.searchUsername,
        start_time: this.startTime,
        end_time: this.endTime
        // order_by: this.order_by
      }
    },
    getBalanceLogListUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.getBalanceLogListUrlPostFix
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    handleTableChange (pagination, filters, sorter) {
      // console.log('handleTableChange')
      const pager = { ...this.pagination }
      pager.current = pagination.current
      this.pagination = pager
      // console.log('sorter', sorter)
      // const { columnKey, order } = sorter
      // this.order_by = {}
      // if (columnKey !== undefined) {
      //   this.order_by[columnKey] = 'asc'
      //   if (order === 'descend') {
      //     this.order_by[columnKey] = 'desc'
      //   }
      //   // console.log('sorter', sorter, columnKey, order)
      // }
      // console.log('filters', filters)
      // this.filters = filters
      this.typeList = (filters['type'] || []).map(item => parseInt(item))
      this.statusList = (filters['status'] || []).map(item => parseInt(item))
      this.fetch()
    },
    fetch () {
      // console.log('fetch')
      console.log('params:', this.params)
      this.loading = true
      axios.post(this.getBalanceLogListUrl, {
        token: sessionStorage.token,
        ...this.params
      })
        .then((data) => {
          if (data.data.err_code === 0) {
            const pagination = { ...this.pagination }
            pagination.total = data.data.content.total_count
            let balanceLogs = data.data.content.balance_logs
            let dataList = []
            balanceLogs.forEach((item) => {
              let balanceLog = item.balance_log
              let chatroomInfo = item.chatroom_info || {}
              let clientInfo = item.client_info
              let balance = balanceLog.balance
              let balanceLogId = balanceLog.balance_log_id
              let change = balanceLog.change
              let status = balanceLog.status
              let type = balanceLog.type
              let createTime = balanceLog.create_time
              // let chatroomname = chatroomInfo.chatroomname
              // let memberCount = chatroomInfo.member_count
              // let chatroomNickname = chatroomInfo.nickname || chatroomInfo.nickname_default || ''
              // let chatroomAvatarUrl = chatroomInfo.avatar_url
              // let clientNickname = clientInfo.nickname
              // let clientAvatarUrl = clientInfo.avatar_url
              // let clientUsername = clientInfo.username
              // let tagList = chatroomTag.tag_list || []
              dataList.push({
                client: clientInfo,
                balance_log_id: balanceLogId,
                type: BALANCE_LOG_TYPE[type] || '-',
                change: change,
                balance: balance,
                status: BALANCE_LOG_STATUS[status] || '-',
                chatroom_info: chatroomInfo,
                create_time: this.transform(createTime, 'yyyy-MM-dd hh:mm:ss')
              })
            })
            this.loading = false
            // console.log('dataList', dataList)
            this.data = dataList
            this.pagination = pagination
          } else if (data.data.err_code === 50002) {
            console.log('token 不对，跳转登录')
            this.$router.push('/')
          }
        })
    },
    transform (value, fmt, ...args) {
      if (typeof value === 'number') {
        // 如果是 秒 为单位就变为毫秒
        if (String(value).length === 10 || String(value).length === 11) value *= 1000

        let date = new Date(value)
        var o = {
          'M+': date.getMonth() + 1, // 月份
          'd+': date.getDate(), // 日
          'h+': date.getHours(), // 小时
          'm+': date.getMinutes(), // 分
          's+': date.getSeconds(), // 秒
          'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
          S: date.getMilliseconds(), // 毫秒
          W: date.getDay()
        }
        var weekMap = [
          '星期日',
          '星期一',
          '星期二',
          '星期三',
          '星期四',
          '星期五',
          '星期六'
        ]
        if (/(y+)/.test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + '').substr(4 - RegExp.$1.length)
          )
        }
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(fmt) && k != 'W') {
            fmt = fmt.replace(
              RegExp.$1,
              RegExp.$1.length == 1
                ? o[k]
                : ('00' + o[k]).substr(('' + o[k]).length)
            )
          }
          if (new RegExp('(' + k + ')').test(fmt) && k == 'W') {
            fmt = fmt.replace(RegExp.$1, weekMap[o[k]])
          }
        }
        return fmt
      } else return ''
    },
    search () {
      this.pagination.current = 1
      this.fetch()
    },
    clear () {
      this.searchUsername = ''
      this.searchNickname = ''
      this.rangeDate = []
      this.search()
    },
    outputExcel () {
      // console.log('outputExcel', this.getChatroomListExcelUrl)
      let baseUrl = global.DOMAIN + global.API_VERSION + this.getBalanceLogListExcelUrlPostFix + '?'
      console.log('outputExcel', baseUrl)
      for (let key in this.params) {
        const value = this.params[key]
        // if (key === 'order_by') {
        //   for (let orderKey in value) {
        //     baseUrl += key + '=' + orderKey + ' ' + value[orderKey] + '&'
        //     break
        //   }
        //   continue
        // }
        baseUrl += key + '=' + value + '&'
      }
      baseUrl += 'token' + '=' + sessionStorage.token
      console.log('outputExcel', baseUrl)
      window.open(baseUrl, '_blank')
    },
    moment,
    onChange (dates, dateStrings) {
      console.log(this.rangeDate)
      if (this.rangeDate.length > 1) {
        this.startTime = parseInt(this.rangeDate[0].valueOf() / 1000)
        this.endTime = parseInt(this.rangeDate[1].valueOf() / 1000)
      } else {
        this.startTime = 0
        this.endTime = 0
      }
      // console.log('From: ', dates[0].valueOf(), ', to: ', dates[1].valueOf())
      // console.log('From: ', dateStrings[0], ', to: ', dateStrings[1])
      // this.startTime = dates[0].valueOf()
      // this.endTime = dates[1].valueOf()
      // this.search()
    }
  }
}
</script>

<style scoped>

</style>
